import React, { useContext, Suspense, lazy, useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import GlobalStyles from "./components/styles/Global";
import Theme from "./components/styles/Theme";
import { Header, LandscapeOverlay, ErrorModal } from "./components/index";
import { Store } from "./context/Store";
import {
  isMobileOnly,
  useMobileOrientation,
  isTablet,
} from "react-device-detect";

const LaunchPage = lazy(() => import("./components/LaunchPage"));
const DpExperience = lazy(() => import("./components/DpExperience"));

declare global {
  interface Window {
    KAMPYLE_ONSITE_SDK: any;
    iagDataLayer: any;
  }
}

const App: React.FC = () => {
  const { state, dispatch } = useContext(Store);
  const { connected, error } = state;
  const { isLandscape } = useMobileOrientation();
  const [mobileLandscape, setMobileLandscape] = useState(isLandscape);

  // We trigger a re render for users when they change to landscape mode
  useEffect(() => {
    dispatch({
      type: "SET_TABLET_LANDSCAPE",
      payload: { tabletLandscape: isLandscape && isTablet },
    });

    if (isLandscape) {
      // Samsung 22 issue. Whenever the keyboard is open, it detects it as an orientation change.
      // We check if the keyboard if open

      if (window.innerWidth > 463) {
        setMobileLandscape(isLandscape);
      }
    } else {
      setMobileLandscape(false);
    }
  }, [isLandscape, dispatch]);

  return (
    <ThemeProvider theme={Theme}>
      <GlobalStyles />
      {/* If we detect a mobile landscape view */}
      {isMobileOnly && mobileLandscape && <LandscapeOverlay />}
      {/* If an error occurs */}
      {error && <ErrorModal />}
      <Header />
      {/* Using lazy loading to reduce bundle size */}
      <Routes>
        <Route
          path="/"
          element={
            <Suspense fallback={<>Loading...</>}>
              <LaunchPage />
            </Suspense>
          }
        />
        <Route
          path="/video"
          element={
            // We trigger startVideo() from this route so we need to make sure users are connected beforehand
            connected ? (
              <Suspense fallback={<>Loading...</>}>
                <DpExperience />
              </Suspense>
            ) : (
              <Navigate to="/" />
            )
          }
        />
      </Routes>
    </ThemeProvider>
  );
};

export default App;
